import React, { useState } from 'react';
import { signIn } from './firebase';
import { Link } from 'react-router-dom';
import logo from './assets/Logo.png'; 
import './SignIn.css';
import { useNavigate } from 'react-router-dom';

function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate()

  const handleSignIn = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signIn(email, password);
      const user = userCredential.user;
      localStorage.setItem('firebaseUser', JSON.stringify(user)); // ✅ Add this line
      alert('Sign In Successful!');
      // redirect logic...
    } catch (err) {
      setError(err.message);
    }
  };
  

  return (
    <div className="signin-container">
      <img src={logo} alt="TOEFL Vocabulary Booster Logo" className="logo" />

      <h2>Sign In to Your Account</h2>

      <form onSubmit={handleSignIn} className="signin-form">
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button type="submit">Sign In</button>

        {error && <p className="error-message">{error}</p>}
      </form>
      <button
  onClick={() => navigate('/reset-password')}
  className="forgot-password-link"
>
  Forgot Password?
</button>

      <p className="switch-page">
        Don’t have an account? <Link to="/signup">Sign Up</Link>
      </p>
    </div>
  );
}

export default SignIn;
